<script setup lang="ts">
import { PhMagnifyingGlass, PhX } from '@phosphor-icons/vue'

import AppScreen from '@/components/layout/AppScreen.vue'
import ScreenTabs from '@/components/layout/ScreenTabs.vue'

import { LOOKUP_TABS } from './tabs'

defineProps<{ placeholder?: string }>()

/**
 * The query lives in the parent screen, not here — each tab filters a different
 * collection, and the shell only owns the chrome.
 */
const query = defineModel<string>({ required: true })
</script>

<template>
  <AppScreen title="Lookup" leading="menu">
    <template #tabs>
      <ScreenTabs :tabs="LOOKUP_TABS" />
    </template>

    <div class="flex h-full min-h-0 flex-col">
      <div class="shrink-0 border-b bg-muted p-2">
        <div class="flex items-center gap-2 border border-input bg-background px-3">
          <PhMagnifyingGlass class="size-4 shrink-0 text-muted-foreground" />
          <input
            v-model="query"
            type="search"
            class="min-h-10 w-full bg-transparent text-sm outline-none placeholder:text-muted-foreground"
            :placeholder="placeholder ?? 'Search'"
            aria-label="Search"
          />
          <button
            v-if="query"
            type="button"
            class="shrink-0 text-muted-foreground"
            aria-label="Clear search"
            @click="query = ''"
          >
            <PhX class="size-4" />
          </button>
        </div>
      </div>

      <slot />
    </div>
  </AppScreen>
</template>
